import React from 'react';
import { number, string, func } from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { fullName, cityRegion } from '../../../utils/text_formatters';
import UserActionFollowCard from '../../cards/actionCards/UserActionFollowCard';
import ActionCardListBase from '../ActionCardListBase';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';

const ActionCardFindFriendsList = ({ header, truncateLimit, className, handleViewAllClick }) => {
  const { members } = useSelector(state => state.findFriends, shallowEqual);
  const { languageRegionCode } = useSelector(state => state.context, shallowEqual);

  return (
    <ActionCardListBase header={header} truncateLimit={truncateLimit} className={className} handleViewAllClick={handleViewAllClick}>
      {members.map(member => {
        return (
          <UserActionFollowCard
            key={member.user.id}
            name={fullName(member.user)}
            subText={cityRegion(member.user.location)}
            profileImageUrl={member.user.profilePhoto.href}
            userLink={LanguageSupportUtil.wrapUrlSafe(`/${member.user.slug}`, languageRegionCode)}
            actions={member.actions}
          />
        );
      })}
    </ActionCardListBase>
  );
};

ActionCardFindFriendsList.propTypes = {
  header: string,
  truncateLimit: number,
  className: string,
  handleViewAllClick: func
};

ActionCardFindFriendsList.defaultProps = {
  header: null,
  truncateLimit: null,
  className: '',
  handleViewAllClick: null
};

export default ActionCardFindFriendsList;
